import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@features/store';

export type CompanyId = 'ecs' | 'ecs-occitanie';

export interface Company {
    id: CompanyId;
    name: string;
    logo: string;
    apiUrl: string;
    appName: string;
}

export type CompanyState = {
    companyChoice: CompanyId | null;
    companyApiUrl: string | null;
    companyAppName: string | null;
};

const initialCompanyState: CompanyState = {
    companyChoice: null,
    companyApiUrl:null,
    companyAppName: null
};

export const companySlice = createSlice({
    name: 'company',
    initialState: initialCompanyState,
    reducers: {
        setCompanyChoice: (state, action: PayloadAction<CompanyId>) => {
            state.companyChoice = action.payload;
        },
        setCompanyApiUrl: (state, action: PayloadAction<string>) => {
            state.companyApiUrl = action.payload;
        },
        setCompanyAppName: (state, action: PayloadAction<string>) => {
            state.companyAppName = action.payload;
        }
    }
});

export const getCompanyChoice = (state: RootState) => state.company?.companyChoice || null;

export const { setCompanyChoice, setCompanyApiUrl, setCompanyAppName } = companySlice.actions;

export default companySlice.reducer;
